import { useEffect, useRef, useState } from "react";
import Money from "src/common/components/money";
import Odd from "src/common/components/odd";
import Tooltip from "src/components/tooltip";
import { decimalString } from "src/constants/types";
import { useTranslation } from "src/hooks/translation";
import { ISystemVariant } from "src/rules/calculation/systemHelpers";

interface IProps {
  variant: ISystemVariant;
  unitStake: decimalString;
  price: number;
};

const CalculatorVariant = ({ variant, unitStake, price }: IProps) => {
  const variantNameElem = useRef<HTMLSpanElement | null>(null);
  const [anchor, setAnchor] = useState<HTMLSpanElement | null>(variantNameElem.current);

  useEffect(() => {
    setAnchor(variantNameElem.current);
  }, [variantNameElem]);

  return (
    <div className="B-variant-item" key={variant.name}>
      <span ref={variantNameElem}>
        {variant.name}
      </span>
      <span>
        {unitStake || 0}
      </span>
      <span>
        <Odd price={price} />
      </span>
      <span>
        <Money amount={price * (+unitStake || 0)} />
      </span>

      {anchor && (
        <Tooltip
          timeout={5000}
          anchor={anchor}
          content={variant.name}
        />
      )}
    </div>
  );
}

export default CalculatorVariant;